import {Role} from 'types';

export const rolesObject = {
  pharmacy_technician: 'Pharmacy Technician',
  dispatcher: 'Dispatcher',
  driver: 'Driver',
  customer_service: 'Customer Service',
  management: 'Management',
  tech: 'Tech',
  front_desk: 'Front-desk',
  prescriber: 'Prescriber',
};

const roles: {value: Role; label: string}[] = Object.entries(rolesObject).map(
  ([value, label]) => ({
    value: value as Role,
    label,
  })
);

export default roles;
